import React from "react";
import {
    DeviceHistoryEntry,
    DeviceHistoryEntryField,
    DeviceHistoryEntryType,
} from "../../../../../app/api/model/deviceHistory";
import {hasJsonStructure} from "../../helpers";
import FirmwareChangedContent from "./components/FirmwareChangedContent";
import FirmwareUpdateScheduledContent from "./components/FirmwareUpdateScheduledContent";
import CheckinContent from "./components/CheckinContent";
import DeviceAssignedContent, {DeviceAssignedContentProps} from "./components/DeviceAssignedContent";
import RdlAuthentication, {RdlAuthenticationProps} from "./components/RdlAuthentication";
import FirmwareUpdate, {FirmwareUpdateProps} from "./components/FirmwareUpdate";
import LastSystemState, {LastSystemStateProps} from "./components/LastSystemState";
import DTCOInfo, {DTCOProps} from "./components/DtcoInfo";

export const SUPPORTED_TYPES = [
    DeviceHistoryEntryType.FIRMWARE_CHANGED,
    DeviceHistoryEntryType.FIRMWARE_UPDATE_SCHEDULED,
    DeviceHistoryEntryType.FIRMWARE_UPDATE,
    DeviceHistoryEntryType.CHECKIN,
    DeviceHistoryEntryType.DEVICE_ASSIGNMENT,
    DeviceHistoryEntryType.RDL_AUTH,
    DeviceHistoryEntryType.LAS_SYS,
    DeviceHistoryEntryType.DTCO,
];

export interface DeviceHistoryInformationContentProps {
    entry: DeviceHistoryEntry;
}

function DeviceHistoryInformationContent({entry}: DeviceHistoryInformationContentProps) {
    const info = entry.information;
    let content: React.ReactNode = info;
    if (hasJsonStructure(info)) {
        switch (entry.type) {
            case DeviceHistoryEntryType.FIRMWARE_UPDATE_SCHEDULED: {
                content = <FirmwareUpdateScheduledContent content={entry[DeviceHistoryEntryField.INFORMATION]} />;
                break;
            }
            case DeviceHistoryEntryType.FIRMWARE_CHANGED: {
                content = <FirmwareChangedContent content={entry[DeviceHistoryEntryField.INFORMATION]} />;
                break;
            }
            case DeviceHistoryEntryType.CHECKIN: {
                content = <CheckinContent content={entry[DeviceHistoryEntryField.INFORMATION]} />;
                break;
            }
            case DeviceHistoryEntryType.DEVICE_ASSIGNMENT: {
                const props = JSON.parse(entry[DeviceHistoryEntryField.INFORMATION]) as DeviceAssignedContentProps;
                content = <DeviceAssignedContent {...props} />;
                break;
            }
            case DeviceHistoryEntryType.RDL_AUTH: {
                const props = JSON.parse(entry[DeviceHistoryEntryField.INFORMATION]) as RdlAuthenticationProps;
                content = <RdlAuthentication {...props} />;
                break;
            }
            case DeviceHistoryEntryType.FIRMWARE_UPDATE: {
                const props = JSON.parse(entry[DeviceHistoryEntryField.INFORMATION]) as FirmwareUpdateProps;
                content = <FirmwareUpdate {...props} />;
                break;
            }
            case DeviceHistoryEntryType.LAS_SYS: {
                const props = JSON.parse(entry[DeviceHistoryEntryField.INFORMATION]) as LastSystemStateProps;
                content = <LastSystemState {...props} />;
                break;
            }
            case DeviceHistoryEntryType.DTCO: {
                const props = JSON.parse(entry[DeviceHistoryEntryField.INFORMATION]) as DTCOProps;
                content = <DTCOInfo {...props} />;
                break;
            }
        }
    }
    return <>{content}</>;
}

export default DeviceHistoryInformationContent;
